import { Agendamento } from '../../Enum';
import { AgendaForm } from '../Form/Form';
import { useAgendaContext } from '../ContextAgenda';

export interface ScheduleViewHeaderProps {
    schedule: Agendamento;
    onEditToggle: () => void;
}

export const FormEditSchedule = ({ schedule, onEditToggle }: ScheduleViewHeaderProps) => {
    const { reloadSchedules } = useAgendaContext();

    return <div className="sf-detail-group is-padded mt-5 py-4">
        <AgendaForm
            onDone={() => {
                reloadSchedules();
                onEditToggle();
            }}
            redirectOnCreate={false}
            forceFloatingButton
            doc={{
                _id: schedule._id,
                price: schedule.totalPrice ?? schedule.service.price,
                subscription: schedule.subscription || null,
                servico_id: schedule.service._id,
                servicos_extras_ids: (schedule.servicosExtras || []).map((extra) => extra._id),
                atendente_id: schedule.attendant.uid,
                duration: schedule.totalDuration ?? schedule.service.duration,
                startAt: new Date(schedule.startAt),
                startMinutes: schedule.startMinutes,
                clientId: schedule.client.uid,
                observation: schedule.observation,
            }}
        />

        <div className="flex justify-center">
            <button
                type="button"
                className="sf-detail-link is-muted"
                onClick={onEditToggle}
            >
                Cancelar edição
            </button>
        </div>
    </div>;
};
